export default class BasicPropertyInfo {
	public constructionType: string | null = null;
	public foundationTypeDetail: string | null = null;
	public buildingReplacementCostValue: number | null = null;
	public floodZone: string | null = null;
	public buildingUse: string | null = null;
	public squareFeet: number | null = null;
	public numberStoriesAboveGrade: number | null = null;
	public yearOfConstruction: number | null = null;

	public constructor() {

	}
};